<template>
  <nav v-if="_g_ShowStockChartMenu" class="legacy-mobile-navigation" aria-label="Navegación del graficador">
    <button type="button" aria-label="Valor anterior" :disabled="index <= 0" @click="$emit('prev-ticker')"><span class="material-icons-outlined" aria-hidden="true">chevron_left</span><span>Anterior</span></button>
    <button type="button" :aria-pressed="String(!toolsOpen && _g_toggle_chart_stocks === 'chart')" @click="select('chart')"><span class="material-icons-outlined" aria-hidden="true">show_chart</span><span>Gráfico</span></button>
    <button type="button" :aria-pressed="String(!toolsOpen && _g_toggle_chart_stocks === 'stocks')" @click="select('stocks')"><span class="material-icons-outlined" aria-hidden="true">list</span><span>Valores</span></button>
    <button type="button" :aria-expanded="String(toolsOpen)" :class="{ active: toolsOpen }" @click="$emit('tools')"><span class="material-icons-outlined" aria-hidden="true">tune</span><span>Herramientas</span></button>
    <button type="button" aria-label="Valor siguiente" :disabled="index < 0 || index >= _g_Stocks.length - 1" @click="$emit('next-ticker')"><span class="material-icons-outlined" aria-hidden="true">chevron_right</span><span>Siguiente</span></button>
  </nav>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  props: { toolsOpen: Boolean },
  computed: {
    ...mapGetters(['_g_ShowStockChartMenu', '_g_toggle_chart_stocks', '_g_Stocks', '_g_SelectedTicker']),
    index() { return this._g_Stocks.findIndex(stock => stock.ticker === (this._g_SelectedTicker || {}).ticker); }
  },
  methods: {
    ...mapMutations(['setToggleChartStocks']),
    select(mode) { this.setToggleChartStocks(mode); this.$emit('change-chart-list'); }
  }
};
</script>
<style scoped>
.legacy-mobile-navigation { position: fixed; bottom: 0; left: 0; right: 0; z-index: 25; display: grid; grid-template-columns: .8fr 1fr 1fr 1.3fr .8fr; padding-bottom: env(safe-area-inset-bottom, 0px); background: var(--color-primary-primary, #11111e); color: white; box-shadow: 0 -1px 6px #0002; }
button { min-width: 0; min-height: 60px; padding: 6px 1px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 3px; border: 0; border-radius: 0; background: transparent; color: inherit; font: inherit; font-size: 11px; cursor: pointer; touch-action: manipulation; }
button[aria-pressed="true"], button.active { background: #007e9e; }
button:disabled { opacity: .35; cursor: default; }
button:focus-visible { outline: 2px solid white; outline-offset: -4px; }
</style>

